<template>
  <q-card flat bordered>
    <q-tabs
      v-model="tab"
      dense
      outside-arrows
      mobile-arrows
      :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 bg-grey-3'"
      active-color="white"
      :active-bg-color="$q.dark.mode ? 'grey-8' : 'blue-4'"
      :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
      align="justify"
      narrow-indicator
    >
      <template v-for="{ name, label, tooltip } in tabNames" :key="name">
        <q-tab class="text-weight-light" :name="name" :label="label" no-caps>
          <q-tooltip v-if="tooltip">{{ tooltip }}</q-tooltip>
        </q-tab>
        <q-separator vertical />
      </template>
    </q-tabs>
    <q-separator />

    <q-tab-panels v-model="tab" animated>
      <q-tab-panel
        v-for="{ name, component } in tabNames"
        :key="name"
        :name="name"
        class="q-pa-none"
      >
        <component
          :is="component"
          :symbol="symbol"
          :isSignalType="isSignalType"
          :signalTypeData="signalTypeData"
          :indicators="indicators"
          :enableDailyWeeklyIntraday="true"
          :signalType="buttonBuyOrSell"
          :alertOrSignal="alertOrSignal"
          :timePeriod="timePeriod"
        />
      </q-tab-panel>
    </q-tab-panels>
  </q-card>
</template>

<script setup>
import { ref, onMounted, markRaw } from "vue";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";

import StockBasicInfo from "src/components/StockBasicInfo.vue";
import StockSignals from "src/components/StockProfile/StockSignals/StockSignals.vue";

import StockWiseBulkTransaction from "src/components/StockProfile/StockWiseBulkTransaction.vue";
import CircuitRange from "src/components/StockProfile/CircuitRange/CircuitRange.vue";
import Broker from "src/components/StockProfile/StockProfileBroker.vue";

import AccumulationDistributionComponents from "src/components/AccumulationDistributionComponents/AccumulationDistributionComponents.vue";
import Technical from "src/components/StockProfile/StockProfileTechnical.vue";

import StockFundamental from "src/components/StockProfile/StockFundamental/StockFundamental.vue";
import StockWiseFloorSheetV2 from "src/components/StockWiseFloorSheetV2.vue";
import PriceHistoryData from "src/components/PriceHistoryData.vue";
import StockMutualFund from "src/components/StockProfile/MutualFund/MutualFund.vue";

// Define the props
const props = defineProps({
  symbol: {
    type: String,
    required: true,
  },
  isSignalType: {
    type: Boolean,
    default: () => false,
  },
  signalTypeData: { type: Array, default: () => [] },
  indicators: {
    type: Array,
  },
  symbol: {
    type: String,
    default: "NEPSE",
  },
  timePeriod: {
    type: String,
    default: "daily",
  },
  enableDailyWeeklyIntraday: {
    type: Boolean,
    default: false,
  },
  backTestdataMini: {
    type: Array,
    default() {
      return ["No Data."];
    },
  },
  candleStickData: {
    type: Array,
    default() {
      return ["No Data."];
    },
  },
  signalTypedata: {
    type: Array,
    default() {
      return ["No Data."];
    },
  },
  isSignalType: {
    type: Boolean,
    default: false,
  },
  buttonBuyOrSell: {
    type: String,
  },
  alertOrSignal: {
    type: String,
  },
});

const $route = useRoute();
const $q = useQuasar();

let tab = ref("");
const tabNames = ref([
  {
    name: "basic_info",
    label: "Basic Info",
    tooltip: "Basic Info",
    component: markRaw(StockBasicInfo),
  },
  {
    name: "stock_signals",
    label: "Signals",
    tooltip: "Signals",
    component: markRaw(StockSignals),
  },
  {
    name: "bulk_tnx",
    label: "Bulk Tnx",
    tooltip: "Bulk Tnx",
    component: markRaw(StockWiseBulkTransaction),
  },
  {
    name: "circuit_range",
    label: "Circuit",
    tooltip: "Circuit Range",
    component: markRaw(CircuitRange),
  },
  {
    name: "broker_analytics",
    label: "Broker",
    tooltip: "Broker",
    component: markRaw(Broker),
  },
  {
    name: "accum_dist",
    label: "Acc/Dist",
    tooltip: "Accumulation/Distribution",
    component: markRaw(AccumulationDistributionComponents),
  },
  {
    name: "technical",
    label: "Technical",
    tooltip: "Technical",
    component: markRaw(Technical),
  },
  {
    name: "fundamental",
    label: "Fundamental",
    tooltip: "Fundamental",
    component: markRaw(StockFundamental),
  },
  {
    name: "floor_sheet",
    label: "Floorsheet",
    tooltip: "Floorsheet",
    component: markRaw(StockWiseFloorSheetV2),
  },
  {
    name: "price_history",
    label: "Price Log",
    tooltip: "Price Log",
    component: markRaw(PriceHistoryData),
  },
  {
    name: "stock_mutual_fund",
    label: "Mutual Fund",
    tooltip: "Mutual Fund",
    component: markRaw(StockMutualFund),
  },
]);

const fundamentalTabs = [
  "quarterly_report",
  "fundamental_chart",
  "stock_dividends",
  "announcement",
];

function changeTab() {
  const { query, name } = $route;
  if (name === "StockProfile") {
    tab.value = fundamentalTabs.includes(query?.signal)
      ? "fundamental"
      : query?.signal || "basic_info";
  } else {
    tab.value = "basic_info";
  }
}

onMounted(() => {
  changeTab();
});
</script>
